import React from 'react'
import { PropTypes } from 'prop-types'
import UniqId from 'uniqid'
import moment from 'moment'
import './cancel_policy_component.scss'
import i18n from '../../../i18n'
import { Trans } from 'react-i18next'

export default class CancelPolicy extends React.Component {
  deadline(diff, { prefix, time } = {}) {
    if (this.props.checkin) {
      return moment(this.props.checkin).add(diff, 'day').format(`YYYY/MM/DD${time ? ` ${time}` : ''}`)
    }
    return `${prefix || ''}${diff == 0 ? i18n.t('common:cancel_policy.that_day') : `${Math.abs(diff)}${i18n.t('common:cancel_policy.days_before')}`}`
  }

  getDescription() {
    switch (this.props.cancelPolicy) {
    case 'flexible':
      return [
        { title: `${this.deadline(-1, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: i18n.t('common:cancel_policy.checkin-day'), value: 100 }
      ]
    case 'normal':
      return [
        { title: `${this.deadline(-5, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: `${this.deadline(-4, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(0)}`, value: 100 }
      ]
    case 'strict':
      return [
        { title: `${this.deadline(-29, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: `${this.deadline(-28, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(-7)}`, value: 50 },
        { title: `${this.deadline(-6, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(0)}`, value: 100 }
      ]
    case 'non_refundable':
      return [
        { title: i18n.t('common:cancel_policy.from_completion'), value: 100 }
      ]
    case 'from_2w':
      return [
        { title: `${this.deadline(-15, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: `${this.deadline(-14, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(0)}`, value: 100 }
      ]
    case 'from_1m':
      return [
        { title: `${this.deadline(-31, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: `${this.deadline(-30, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(0)}`, value: 100 }
      ]
    case 'from_2m':
      return [
        { title: `${this.deadline(-61, { prefix: i18n.t('common:cancel_policy.checkin'), time: '23:59' })}`, value: 0 },
        { title: `${this.deadline(-60, { prefix: i18n.t('common:cancel_policy.checkin') })} - ${this.deadline(0)}`, value: 100 }
      ]
    default:
      return []
    }
  }

  render() {
    return (
      <React.Fragment>
        <p className="n-text">{i18n.t('common:cancel_policy.title')}</p>
        <dl styleName="cancel-policy-description" className="n-text">
          {this.getDescription().map(({ title, value }) => {
            return (
              <div styleName="cancel-policy-row" key={UniqId()}>
                <dt styleName ={`cancel-policy-span${value == 0 ? ' free' : ''}`}>
                  <span>{title}</span>
                  <span>
                    {value == 0
                      ? <Trans i18nKey='common:cancel_policy.free_cancellation'>
                        <React.Fragment><span>&nbsp;（現地時間）までは</span><span styleName="cancel-free">キャンセル無料</span>
                        </React.Fragment></Trans> : '' }
                  </span>
                </dt>
                { value > 0 && <dd styleName="cancel-policy-rate">{i18n.t('common:cancel_policy.total_price_ratio', {n: value})}</dd> }
              </div>
            )
          })}
        </dl>
        <p className="n-text" tx-content="translate_urls">
          {i18n.t('common:cancel_policy.message', {site_name: i18n.t('common:site_name')})}<br/>
          <a className="bl-link" href={i18n.t('common:cancel_policy.faq_url')} target="_blank">{i18n.t('common:cancel_policy.click_detail')}</a>
        </p>
      </React.Fragment>
    )
  }
}

CancelPolicy.propTypes = {
  cancelPolicy: PropTypes.string.isRequired,
  checkin: PropTypes.string
}

CancelPolicy.defaultProps = {
  cancelPolicy: ''
}
